import speedtest_component from '#BASE/components/speedTest/speedTest.component';
import downloadcenter_component from '#BASE/components/downLoad/DownLoadCenter';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import loginEntryDownload from 'TY/components/Download/loginEntryDownload.component';

export default {
    mixins: [speedtest_component, loginEntryDownload, downloadcenter_component],
    components: { 
        qrcode: VueQrcode,
    },
    data: function () {
        return {
            QrcodeOptions: {
                width: 112,
                margin: 1
            }
        };
    },
    computed: {
        year(){
            return new Date().getFullYear();
        },
        AndroidURL() {
            if (this.androidUrl == "javascript:void(0);" )
                this.androidUrl = this.AndroidOrPcFile("apk");

            return this.androidUrl;
        }
    },
};